import { render, staticRenderFns } from "./ConfiguracoesMensagemRespostaAutomatica.vue?vue&type=template&id=50458984"
import script from "./ConfiguracoesMensagemRespostaAutomatica.vue?vue&type=script&lang=js"
export * from "./ConfiguracoesMensagemRespostaAutomatica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports